(ns ui.components.tiptap.mention-list
  (:require
   ["react" :refer [forwardRef useEffect useImperativeHandle useState]]
   [reagent.core :as r]))

(def mention-list
  (forwardRef
   (fn [props ref]
     (let [selected-index  (useState 0)
           items           (.-items props)
           command         (.-command props)
           setSelectedIndex (aget selected-index 1)
           currentIndex    (aget selected-index 0)]

       (useEffect
        (fn []
          (setSelectedIndex 0)
          js/undefined)
        #js [items])

       (useImperativeHandle ref
                            (fn []
                              #js {:onKeyDown (fn [js-arg]
                                               (let [{:keys [event]} (js->clj js-arg :keywordize-keys true)]
                                                 (case (.-key event)
                                                   "ArrowUp"
                                                   (do (setSelectedIndex (mod (+ currentIndex (count items) -1) (count items)))
                                                       true)

                                                   "ArrowDown"
                                                   (do (setSelectedIndex (mod (+ currentIndex 1) (count items)))
                                                       true)

                                                   "Tab"
                                                   (do (if (.-shiftKey event)
                                                         (setSelectedIndex (mod (+ currentIndex (count items) -1) (count items)))
                                                         (setSelectedIndex (mod (+ currentIndex 1) (count items))))
                                                       (.preventDefault event)
                                                       true)

                                                   "Enter"
                                                   (do (when-let [item (aget items currentIndex)]
                                                         (.call command nil #js {:id item}))
                                                       true)

                                                   false)))}))

       (r/as-element
        [:div {:class "p-2 border rounded bg-white"}
         (if (seq items)
           (for [i (range (count items))]
             (let [item (aget items i)]
               ^{:key i}
               [:button {:on-click #(command #js {:id item})
                         :class    (str "block w-full text-left px-2 py-1 "
                                        (when (= i currentIndex) "bg-gray-200"))}
                item]))
           [:div {:class "italic text-gray-500"} "No result"])])))))
